"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storageKey = exports.hamplitudeKey = exports.hstcKey = exports.debugKey = exports.accountId = void 0;
var accountId = 53;
exports.accountId = accountId;
var debugKey = 'USAGE_TRACKER_JS';
exports.debugKey = debugKey;
var hstcKey = '__hstc';
exports.hstcKey = hstcKey;
var hamplitudeKey = '__hmpl';
exports.hamplitudeKey = hamplitudeKey;
var storageKey = "HUBLYTICS_EVENTS_" + accountId;
exports.storageKey = storageKey;